export default ({ testWindow, orderedItems = [] }) => (
  <>
    {orderedItems.length > 0 ? (
      <>
        <h5>{testWindow}</h5>
        {orderedItems.map((orderedItem, i) => (
          <div
            key={orderedItem.ancillaryCd}
            style={{
              backgroundColor: '#fff',
              border: '1px solid #ccc',
              padding: '5px',
              marginBottom: `${i < orderedItems.length - 1 ? '5px' : '0'}`,
            }}
          >
            <h6 style={{ fontWeight: 'bold', fontSize: '1em' }}>{orderedItem.name}</h6>
            {orderedItem.description && <div>{orderedItem.description}</div>}
            <div>Qty: {orderedItem.quantity}</div>
          </div>
        ))}
      </>
    ) : null}
  </>
)
